import { render, staticRenderFns } from "./WarnChanges.vue?vue&type=template&id=c93b47e0"
import script from "./WarnChanges.vue?vue&type=script&lang=ts"
export * from "./WarnChanges.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports